import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  borrower: [{
    fullName: '',
    idNumber: '',
    phoneNumber: '',
    email: '',
    city: '',
    address: '',
  }],
  extraDetails: {
    propertyValuation: null,
    loanTypeName: null,
    loanTypeNameHebrew: null,
    loan: null,
    loanAmount: null,
    income: null,
    outcome: null,
    businessCredit: null,
    youngestBorrowerDOB: null,
    oldestBorrowerDOB: null,
    numberOfBorrowers: 1,
    isRecycling: null,
    selectedRisk: null,
    isApprovedClient: null,
    clientId: null,
  },
  id: null,
};

const proposalSlice = createSlice({
  name: 'proposal',
  initialState,
  reducers: {
    updateBorrower: (state, action) => ({ ...state, ...{ borrower: action.payload } }),
    updateFirstBorrower: (state, action) => {
      if (state.borrower.length > 0) {
        Object.assign(state.borrower[0], action.payload);
      } else {
        state.borrower.push({ ...action.payload });
      }
    },
    updateExtraDetails: (state, action) => ({
      ...state, ...{ extraDetails: { ...state.extraDetails, ...action.payload } },
    }),
    updateProposal: (state, action) => ({ ...state, ...action.payload }),
    resetPoposal: () => initialState,
  },
});

export { initialState };
export const {
  updateBorrower,
  updateFirstBorrower,
  updateExtraDetails,
  updateProposal,
  resetPoposal,
} = proposalSlice.actions;
export default proposalSlice.reducer;
